import React, { Component, createContext, useContext } from 'react'
import { get, patch } from 'api'
import { useAuth } from 'contexts/auth'
import PubSub from 'pubsub-js'
import debounce from 'lodash.debounce'
import { getChannel } from 'utilities/broadcaster'

const AccountContext = createContext()
AccountContext.displayName = 'Account'

class AccountProvider extends Component {
    constructor(props) {
        super(props)

        this.fetchDebounced = debounce(this.fetch, 1000, {
            leading: true,
            trailing: false
        })

        this.state = {
            account: null,
            fetching: false,
            challenged: false,

            fetch: this.fetchDebounced,
            update: this.update
        }

        this.subscription = PubSub.subscribe('account.refresh', () => this.fetchDebounced())
        this.syncer = getChannel('account')
    }

    componentDidMount() {
        this.syncer.onmessage = ({ data }) => void this.setState(data)
        this.props.authorized && this.fetch()
    }

    componentDidUpdate({ authorized: wasAuthorized }) {
        if(!this.state.account && !this.state.fetching && !wasAuthorized && this.props.authorized) {
            this.fetch()
        }
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.subscription)
        this.syncer.close()
    }

    fetch = async () => {
        this.setState({ fetching: true })
        const { ok, response: account } = await get({ path: '/organization/account' })

        let state = { fetching: false }

        if(ok && account) {
            state = {
                ...state,
                account,
                challenged: !!account?.challenges?.length
            }
        }

        this.setState(state, () => this.syncer.postMessage(state))

        return { ok, response: account }
    }

    update = async body => {
        const { ok, response: account } = await patch({
            path: '/organization/account',
            body
        })

        if(ok && account) {
            const state = {
                account,
                challenged: !!account?.challenges?.length
            }

            this.setState(state, () => this.syncer.postMessage(state))
        }

        return { ok, response: account }
    }

    render() {
        const { children = null } = this.props

        return (
            <AccountContext.Provider value={this.state}>
                {(typeof children === 'function') && children(this.state)}
                {(typeof children !== 'function') && children}
            </AccountContext.Provider>
        )
    }
}

export const useAccount = () => useContext(AccountContext)

export default props => {
    const { status } = useAuth()

    return (
        <AccountProvider
            {...props}
            authorized={status === 'authorized'} />
    )
}